module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }